module.exports = __webpack_public_path__ + "img/AlmanacPlusLogoFinal.521f36cc.svg";